module.exports = __webpack_public_path__ + "static/media/biteship-logo-icon.372c6cf9.png";